import { ChemicalBM } from '../../types/BusinessModel/TankCleaning/ChemicalBM';
import { Chemical } from '../../types/ViewModel/TankCleaning/Chemical';

export const createChemical = (chemical: ChemicalBM): Chemical => {
    return {
        chemicalId: chemical.chemicalId,
        categoryId: chemical.categoryId,
        category: undefined,
        name: chemical.name,
        supplierId: chemical.supplierId,
        supplier: undefined,
        unitId: chemical.unit,
        unit: undefined,
        robLocationDropdownId: chemical.robLocationDropdownId,
    };
};

export const createChemicalList = (chemicals: ChemicalBM[]) => chemicals.map((chemical) => createChemical(chemical));
